import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i6.21
import React from 'react';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import IconWrap from '../../IconWrap';
const ChangeBg = (props)=>{
    const uniqueId = useUniqueId();
    const gradientId = `icon-i08-${uniqueId}-a`;
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: gradientId,
        x1: "10.264%",
        x2: "91.383%",
        y1: "9.695%",
        y2: "91.6%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FCF53C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "43.255%",
        stopColor: "#FF5DD3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "64.162%",
        stopColor: "#078BFB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#06D290"
    }))), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(2 3)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "18",
        height: "18",
        x: "1",
        fill: `url(#${gradientId})`,
        rx: "1"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "nonzero",
        d: "M19 0a1 1 0 011 1v16a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h18zm-1 2H2v14h16V2z"
    }))));
};
ChangeBg.displayName = 'ChangeBg';
export default ChangeBg;
